module.exports = __webpack_public_path__ + "img/postman_visiteur_login.ad8ee135.png";